/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { ChangeDetectorRef, Directive } from '@angular/core';

@Directive()
export abstract class BaseMessageComponent {
  private _returnMessage = '';

  get returnMessage(): string {
    return this._returnMessage;
  }

  set returnMessage(value: string) {
    this._returnMessage = value;
    this.cdr.detectChanges();
  }

  constructor(protected readonly cdr: ChangeDetectorRef) {}

  onBlur(obj: any): void {
    if (obj.srcElement.value.length === 0) {
      obj.srcElement.className = 'modelo-text-input';
    } else {
      obj.srcElement.className = 'modelo-text-input ng-not-empty';
    }
  }
}
